// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1200px) {
  .mob-pt {
    padding-top: 50px !important;
  }
}
@media only screen and (max-width: 600px) {
  .fontsmall {
    font-size: small !important;
  }
}
@media (min-width: 900px) {
  .css-zcy9rs-MuiGrid-root {
    max-width: 30% !important;
  }
}
.bio {
  width: 100% !important;
  max-width: 100% !important;
  text-align: justify !important;
  /* makes left + right edges aligned */
  text-justify: inter-word !important;
  /* evenly spaces words */
  white-space: pre-wrap !important;
  /* preserves user line breaks */
  word-break: normal !important;
  /* do NOT break words in the middle */
  overflow-wrap: break-word !important;
  /* wrap long words naturally */
}

@media only screen and (max-width: 767px) {
  .hide-org {
    display: none !important;
  }
  .fixed-button2 {
    display: block !important;
    position: fixed;
    bottom: 40px;
    /* Adjust this value to change the distance from the bottom */
    right: 20px;
    /* Adjust this value to change the distance from the right */
    z-index: 9999;
    /* Ensure the button appears above other elements */
    color: #fff;
    padding: 15px 20px;
    border-radius: 50%;
    cursor: pointer;
  }
  .btn-mrgtop {
    margin-top: 10px !important;
  }
}
@media only screen and (min-width: 767px) {
  .show-mile {
    display: none !important;
  }
  .fixed-button2 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/ui/profile/profile-details/profile-details.scss"],"names":[],"mappings":"AAAA;EACE;IACE,4BAAA;EACF;AACF;AAEA;EACE;IACE,2BAAA;EAAF;AACF;AAGA;EACE;IACE,yBAAA;EADF;AACF;AAIA;EACE,sBAAA;EACA,0BAAA;EAEA,8BAAA;EACA,qCAAA;EACA,mCAAA;EACA,wBAAA;EAEA,gCAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,oCAAA;EACA,8BAAA;AAJF;;AAOA;EACE;IACE,wBAAA;EAJF;EAOA;IACE,yBAAA;IACA,eAAA;IACA,YAAA;IACA,6DAAA;IACA,WAAA;IACA,4DAAA;IACA,aAAA;IACA,mDAAA;IACA,WAAA;IACA,kBAAA;IACA,kBAAA;IACA,eAAA;EALF;EAQA;IACE,2BAAA;EANF;AACF;AASA;EACE;IACE,wBAAA;EAPF;EAUA;IACE,aAAA;EARF;AACF","sourcesContent":["@media only screen and (max-width: 1200px) {\n  .mob-pt {\n    padding-top: 50px !important;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .fontsmall {\n    font-size: small !important;\n  }\n}\n\n@media (min-width: 900px) {\n  .css-zcy9rs-MuiGrid-root {\n    max-width: 30% !important;\n  }\n}\n\n.bio {\n  width: 100% !important;\n  max-width: 100% !important;\n\n  text-align: justify !important;\n  /* makes left + right edges aligned */\n  text-justify: inter-word !important;\n  /* evenly spaces words */\n\n  white-space: pre-wrap !important;\n  /* preserves user line breaks */\n  word-break: normal !important;\n  /* do NOT break words in the middle */\n  overflow-wrap: break-word !important;\n  /* wrap long words naturally */\n}\n\n@media only screen and (max-width: 767px) {\n  .hide-org {\n    display: none !important;\n  }\n\n  .fixed-button2 {\n    display: block !important;\n    position: fixed;\n    bottom: 40px;\n    /* Adjust this value to change the distance from the bottom */\n    right: 20px;\n    /* Adjust this value to change the distance from the right */\n    z-index: 9999;\n    /* Ensure the button appears above other elements */\n    color: #fff;\n    padding: 15px 20px;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n\n  .btn-mrgtop {\n    margin-top: 10px !important;\n  }\n}\n\n@media only screen and (min-width: 767px) {\n  .show-mile {\n    display: none !important;\n  }\n\n  .fixed-button2 {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
